import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button } from "@bookips/solvook-ui-library";
import { Box, Divider, styled as muiStyled, Typography } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import Icon from "../icon/Icon";
import { MenuBook, Sizes } from "../icon/IconList";
import { PassPromotion } from "./PassPromotion";
export const PromotionLinks = (param)=>{
    let {} = param;
    const router = useRouter();
    return /*#__PURE__*/ _jsxs(PromotionStack, {
        children: [
            /*#__PURE__*/ _jsx(Link, {
                href: "/pod",
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ _jsx(Box, {
                    sx: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ _jsx(Button, {
                        size: "xsmall",
                        onClick: ()=>{
                            mixpanelEvent("POD Service Clicked", {
                                "Button Name": "제본 서비스",
                                Position: "Home Sub Menu"
                            });
                        },
                        label: /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                display: "flex",
                                gap: "4px"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    icon: MenuBook,
                                    size: Sizes.small
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "subtitle2",
                                    children: "제본 서비스"
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "label",
                                    component: "span",
                                    sx: (theme)=>({
                                            color: theme.palette.red[400],
                                            alignSelf: "center"
                                        }),
                                    children: "N"
                                })
                            ]
                        }),
                        variant: "textSecondary"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ButtonDivider, {
                orientation: "vertical",
                textAlign: "center"
            }),
            /*#__PURE__*/ _jsx(PassPromotion, {})
        ]
    });
};
export const ButtonDivider = muiStyled(Divider)((param)=>{
    let { theme  } = param;
    return {
        height: "14px",
        margin: "5px 0",
        color: theme.palette.grey["100"]
    };
});
export const PromotionStack = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("md")]: {
            flexShrink: 0,
            padding: "0 32px 0 0"
        },
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    };
});
